import React from 'react';
import {useSelector} from 'react-redux';
import Questionnaire1Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire7Screen';
import Questionnaire10Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire10Screen';
import Questionnaire8Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/menopause-teleconsultation/Questionnaire9Screen';
import {RootState} from '~/redux/root-reducer';
import {MENOPAUSE_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const MenopauseTeleconsultation = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case MENOPAUSE_TELECONSULTATION_KEYS.START:
        trackPageViewGA('/menopause-tel/start', 'MDQ-Menopause Tel - Start');
        return <Questionnaire1Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.PROFILE:
        trackPageViewGA('/menopause-tel/profile', 'MDQ-Menopause Tel - Profile');
        return <Questionnaire2Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.INVALID:
        trackPageViewGA('/menopause-tel/invalid', 'MDQ-Menopause Tel - Invalid');
        return <Questionnaire3Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA('/menopause-tel/select-symptoms', 'MDQ-Menopause Tel - Select Symptoms');
        return <Questionnaire4Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.DESCRIBE_CURRENT_SYMPTOMS:
        trackPageViewGA('/menopause-tel/describe-current-symptoms', 'MDQ-Menopause Tel - Describe Current Symptoms');
        return <Questionnaire5Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.HAVING_REGULAR_PERIODS:
        trackPageViewGA('/menopause-tel/having-regular-periods', 'MDQ-Menopause Tel - Having Regular Periods');
        return <Questionnaire6Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING:
        trackPageViewGA(
          '/menopause-tel/current-or-history-of-any-of-following',
          'MDQ-Menopause Tel - Current Or History Of Any Of Following',
        );
        return <Questionnaire7Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS:
        trackPageViewGA(
          '/menopause-tel/up-to-date-pap-smears-cervical-screenings',
          'MDQ-Menopause Tel - Up To Date Pap Smears Cervical Screenings',
        );
        return <Questionnaire8Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.UP_TO_DATE_BREAST_SCREENINGS:
        trackPageViewGA(
          '/menopause-tel/up-to-date-breast-screenings',
          'MDQ-Menopause Tel - Up To Date Breast Screenings',
        );
        return <Questionnaire9Screen />;
      case MENOPAUSE_TELECONSULTATION_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/menopause-tel/other-condition-or-medical-history',
          'MDQ-Menopause Tel - Other Condition Or Medical History',
        );
        return <Questionnaire10Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default MenopauseTeleconsultation;
